define('rest/search',['http', './utils', 'security', 'endpoints'], function(http, utils, security, endpoints) {
    'use strict';

    var queryParamsNames = [
        'typeahead', 'limit', 'offset', 'countrySet', 'lat', 'lon', 'language',
        'radius', 'topLeft', 'btmRight', 'idxSet', 'maxFuzzyLevel', 'geometryList'
    ];

    return {
        search: function(options, callback) {
            var pathParams = {};
            var queryParams = {};

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey('services/search'));

            // get required query statement
            pathParams.query = utils.required(options.query, 'Missing query statement in Search service');
            pathParams.type = utils.required(options.type, 'Missing type definition in Search service');

            // look for optional passed params and set them if they are not undefined
            utils.extractQueryParams(options, queryParams, queryParamsNames);

            http.get({
                url: '{protocol}://' + endpoints.search,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                callbackParam: 'callback',
                fail: options.fail
            });
        }
    };
});

